"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PagedComments;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _CleveronMiniLogo = _interopRequireDefault(require("../CleveronMiniLogo"));
var _CommentsBlock = require("../CommentsBlock");
var _ConfirmDialog = _interopRequireDefault(require("../ConfirmDialog"));
var _excluded = ["hideIfEmpty", "comments", "value"];
var _SendIcon, _Grid, _Grid2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    tab: {
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '150%',
      minHeight: '32px',
      minWidth: '120px',
      textTransform: 'none'
    },
    tabs: {
      marginBottom: theme.spacing(2),
      minHeight: '32px'
    },
    tabSelected: {
      color: theme.palette.primary.main
    }
  };
});
function SubmitBox(_ref) {
  var onSubmit = _ref.onSubmit,
    id = _ref.id;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    id: "".concat(id, "Comment"),
    label: formatMessage({
      defaultMessage: 'Add comment',
      id: 'field.addComment'
    }),
    margin: "dense",
    multiline: true,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    value: value,
    variant: "outlined"
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    clone: true,
    mt: 1.5
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    disabled: !value || value.length === 0,
    id: "".concat(id, "SubmitButton"),
    onClick: function onClick() {
      onSubmit({
        comment: value
      }).then(function () {
        return setValue('');
      }).catch(function () {});
    },
    size: "small"
  }, _SendIcon || (_SendIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.Send, null))))));
}
function PagedComments(_ref2) {
  var _ref2$deleteEditFilte = _ref2.deleteEditFilter,
    deleteEditFilter = _ref2$deleteEditFilte === void 0 ? function () {
      return true;
    } : _ref2$deleteEditFilte,
    handleDelete = _ref2.handleDelete,
    handleEdit = _ref2.handleEdit,
    handleSubmit = _ref2.handleSubmit,
    _ref2$hideTabsIfOnlyO = _ref2.hideTabsIfOnlyOne,
    hideTabsIfOnlyOne = _ref2$hideTabsIfOnlyO === void 0 ? false : _ref2$hideTabsIfOnlyO,
    domId = _ref2.id,
    _ref2$newestFirst = _ref2.newestFirst,
    newestFirst = _ref2$newestFirst === void 0 ? false : _ref2$newestFirst,
    _ref2$pageSize = _ref2.pageSize,
    pageSize = _ref2$pageSize === void 0 ? 10 : _ref2$pageSize,
    tabs = _ref2.tabs;
  var classes = useStyles();
  var _useIntl2 = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl2.formatMessage;
  var _useState3 = (0, _react.useState)(tabs == null ? void 0 : tabs[0].value),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    openedTab = _useState4[0],
    setOpenedTab = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    deletableComment = _useState6[0],
    setDeletableComment = _useState6[1];
  var _useState7 = (0, _react.useState)(tabs.reduce(function (acc, t) {
      return (0, _extends2.default)({}, acc, {
        [t.value]: pageSize
      });
    }, {})),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    tabOffsets = _useState8[0],
    setTabOffsets = _useState8[1];

  /* Turn our array into an object and sort the comments */
  var transformedTabs = (0, _react.useMemo)(function () {
    return tabs.reduce(function (acc, _ref3) {
      var hideIfEmpty = _ref3.hideIfEmpty,
        comments = _ref3.comments,
        value = _ref3.value,
        rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
      if (hideIfEmpty && comments.length === 0) {
        return acc;
      }
      return (0, _extends2.default)({}, acc, {
        [value]: (0, _extends2.default)({}, rest, {
          comments: comments.sort(function (a, b) {
            return new Date(a.createdAt) - new Date(b.createdAt);
          }),
          value
        })
      });
    }, {});
  }, [tabs]);
  var currentTabOffset = tabOffsets[openedTab];
  var currentComments = transformedTabs[openedTab].comments;
  var visibleComments = (0, _react.useMemo)(function () {
    var comments = currentComments.slice(-currentTabOffset).map(function (c) {
      return (0, _extends2.default)({}, c, {
        Logo: c.companyKey === 'CLEVERON' && _CleveronMiniLogo.default
      }, handleDelete && deleteEditFilter(c) && {
        onDelete: function onDelete(d) {
          return setDeletableComment(d);
        }
      }, handleEdit && deleteEditFilter(c) && {
        onEdit: function onEdit(_ref4) {
          var id = _ref4.id,
            newValue = _ref4.comment;
          return handleEdit((0, _extends2.default)({}, c, {
            id,
            newValue
          }), openedTab);
        }
      });
    });
    if (newestFirst) {
      comments.reverse();
    }
    return comments;
  }, [currentComments, currentTabOffset, deleteEditFilter, handleDelete, handleEdit, newestFirst, openedTab]);
  var commentsToShowMoreOnNextPage = visibleComments.length + pageSize > currentComments.length ? currentComments.length - visibleComments.length : pageSize;
  var commentsHidden = currentComments.length - visibleComments.length;
  var content = [currentComments.length > pageSize && currentComments.length !== visibleComments.length && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    key: "more",
    alignItems: "center",
    container: true,
    spacing: 1
  }, _Grid || (_Grid = /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react.default.createElement(_material.Divider, null))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    color: "primary",
    onClick: function onClick() {
      return setTabOffsets((0, _extends2.default)({}, tabOffsets, {
        [transformedTabs[openedTab].value]: tabOffsets[openedTab] + pageSize
      }));
    },
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "Show {n} more {total, plural, =0 {} other {({total} total)}}",
    id: "actions.showNmoreOfTotal",
    values: {
      n: commentsToShowMoreOnNextPage,
      total: commentsHidden === commentsToShowMoreOnNextPage ? 0 : commentsHidden
    }
  }))), _Grid2 || (_Grid2 = /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react.default.createElement(_material.Divider, null)))), /*#__PURE__*/_react.default.createElement(_CommentsBlock.CommentsList, {
    key: "list",
    comments: visibleComments,
    dividerAfter: handleSubmit && !newestFirst,
    dividerBefore: handleSubmit && newestFirst,
    id: "".concat(domId, "Comments")
  }), handleSubmit && /*#__PURE__*/_react.default.createElement(SubmitBox, {
    key: "new",
    id: "".concat(domId, "NewCommentForm"),
    onSubmit: function onSubmit(comment) {
      return handleSubmit(comment, openedTab);
    }
  })];
  if (newestFirst) {
    content.reverse();
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(hideTabsIfOnlyOne && Object.values(transformedTabs).length === 1) && /*#__PURE__*/_react.default.createElement(_material.Tabs, {
    classes: {
      root: classes.tabs
    },
    id: "".concat(domId, "CommentsTabs"),
    indicatorColor: "primary",
    scrollButtons: "auto",
    value: openedTab,
    variant: "scrollable"
  }, tabs.map(function (_ref5) {
    var title = _ref5.title,
      titleKey = _ref5.titleKey,
      value = _ref5.value,
      hideIfEmpty = _ref5.hideIfEmpty,
      comments = _ref5.comments;
    return !(hideIfEmpty && comments.length === 0) && /*#__PURE__*/_react.default.createElement(_material.Tab, {
      key: titleKey || title,
      classes: {
        root: classes.tab,
        selected: classes.tabSelected
      },
      id: "".concat(domId, "CommentsPage").concat(title, "-").concat(value),
      label: titleKey ? formatMessage({
        id: titleKey
      }) : title,
      onClick: function onClick() {
        return setOpenedTab(value);
      },
      value: value
    });
  })), content, handleDelete && /*#__PURE__*/_react.default.createElement(_ConfirmDialog.default, {
    confirmKey: "actions.delete",
    id: "".concat(domId, "DeleteConfirmation"),
    onClose: function onClose() {
      return setDeletableComment(null);
    },
    onConfirm: function onConfirm() {
      handleDelete(deletableComment, openedTab);
      setDeletableComment(null);
    },
    open: !!deletableComment,
    titleKey: "actions.q_deleteComment"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, deletableComment == null ? void 0 : deletableComment.body)));
}